
import { IonItem, IonLabel, IonRadio, IonRadioGroup } from "@ionic/react";
import React, { useEffect, useState } from "react";

// Question interface
interface QuestionData {
    question: string;
    correct: boolean;
}


const TrueFalse: React.FC = () => {
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [selectedOption, setSelectedOption] = useState<string | boolean | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    // Fetch question data from an external source (replace with your actual API or JSON URL)
    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'TrueFalsePlants.json');
                data = await response.json();
            } else {
                const module = await import('../../../../datas/TrueFalsePlants.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        // Simulating an API fetch to load questions
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - Environmental Science - Plants - True / False"; // Set page title
    }, []);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const handleOptionClick = (selectedMyOption: boolean) => {
        console.log(selectedMyOption)
        const currentQuestion = questions[currentIndex];
        setSelectedOption(selectedMyOption);
        if (selectedMyOption === currentQuestion.correct) {
            setError(false);
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                }
                setShowImage(false);
                setError(false);
                setSelectedOption(null)
            }, 5000); // Shortened delay to 3 seconds
        } else {
            setError(true);
        }
    };

    return (
        <>
            {
                showImage === false ?
                    <>
                        <div className="contentPart seasons additionWord" style={{marginTop: "0%"}}>
                            <div className="mt-4 mb-4">
                                <h3 className="mb-2">
                                    {questions[currentIndex]?.question}
                                </h3>
                            </div>

                            <IonRadioGroup onIonChange={(e) => handleOptionClick(e.detail.value!)}>
                                <IonItem
                                    className={`grid-item ${selectedOption === true
                                        ? true === questions[currentIndex]?.correct
                                            ? "correct"
                                            : "errorItems"
                                        : ""
                                        }`}>
                                    <IonRadio slot="start" value={true} />
                                    <IonLabel>True</IonLabel>
                                </IonItem>
                                <IonItem
                                    className={`grid-item ${selectedOption === false
                                        ? false === questions[currentIndex]?.correct
                                            ? "correct"
                                            : "errorItems"
                                        : ""
                                        }`}>
                                    <IonRadio slot="start" value={false} />
                                    <IonLabel>False</IonLabel>
                                </IonItem>
                            </IonRadioGroup>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default TrueFalse;
